var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st104{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st103{fill:#FFFFFF;}\n\t.st102{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st101{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:2.9608,2.9608;}\n\t.st100{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3.0038,3.0038;}\n\t.st99{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:2.963,2.963;}\n\t.st98{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:2.9458,2.9458;}\n\t.st97{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3.047,3.047;}\n\t.st96{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:2.9322,2.9322;}\n\t.st95{fill:#010101;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "348.79,179.2 348.79,340.68 223.86,340.68 197.4,314.2 197.4,179.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st103",
    points: "344.22,336.11 225.75,336.11 201.96,312.31 201.96,183.76 344.22,183.76  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st102",
    x1: 344.22,
    y1: 336.11,
    x2: 342.72,
    y2: 336.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st101",
    x1: 339.76,
    y1: 336.11,
    x2: 228.73,
    y2: 336.11
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st102",
    points: "227.25,336.11 225.75,336.11 224.69,335.05  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st100",
    points: "222.57,332.93 201.96,312.31 201.96,186.77  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st102",
    points: "201.96,185.26 201.96,183.76 203.46,183.76  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st99",
    x1: 206.42,
    y1: 183.76,
    x2: 341.24,
    y2: 183.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st102",
    x1: 342.72,
    y1: 183.76,
    x2: 344.22,
    y2: 183.76
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "74.21,178.16 74.21,341.84 192.16,341.84 218.9,315 218.9,178.16  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st103",
    points: "78.78,182.73 214.34,182.73 214.34,313.12 190.27,337.27 78.78,337.27  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st102",
    x1: 78.78,
    y1: 182.73,
    x2: 80.28,
    y2: 182.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "st98",
    x1: 83.22,
    y1: 182.73,
    x2: 211.37,
    y2: 182.73
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st102",
    points: "212.84,182.73 214.34,182.73 214.34,184.23  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st97",
    points: "214.34,187.27 214.34,313.12 192.4,335.13  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st102",
    points: "191.33,336.21 190.27,337.27 188.77,337.27  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st96",
    x1: 185.84,
    y1: 337.27,
    x2: 81.74,
    y2: 337.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st102",
    x1: 80.28,
    y1: 337.27,
    x2: 78.78,
    y2: 337.27
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.15,
    y: 258.31,
    className: "st95",
    width: 38.34,
    height: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st95",
    cx: 184.67,
    cy: 260.13,
    r: 15.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotch1);
export default __webpack_public_path__ + "static/media/NOTCH 1.372fa1c2b27d8fccd9fc3afd572f55e7.svg";
export { ForwardRef as ReactComponent };